import Vue from 'vue'
import api from '@/api/index'
Vue.prototype.$api = api



// WEBPACK FOOTER //
// ./src/plugins/api.js